<p-toast position="top-right" key="general" closable="false">
  <ng-template let-message pTemplate="message">
    <div class="d-flex" style="flex: 1">
      <div class="d-flex align-items-center justify-content-center">
        <span class="circle-box">
          @switch (message.severity) {
            @case ('success') {
              <mat-icon class="circle-box-icon">check</mat-icon>
            }
            @case ('warn') {
              <mat-icon class="circle-box-icon">warning_amber</mat-icon>
            }
            @case ('error') {
              <mat-icon class="circle-box-icon">close</mat-icon>
            }
            @case ('info') {
              <mat-icon class="circle-box-icon" fontSet="material-icons-outlined">info</mat-icon>
            }
          }
        </span>
      </div>
      <div class="ms-3">
        <p class="fw-bold m-0" style="color: #000;font-size: 17px;">{{message.summary}}</p>
        <p class="m-0" style="color: #7E7D7D;">{{message.detail}}</p>
      </div>
      <div class="d-flex align-items-center justify-content-center ms-auto">
        <mat-icon class="project-alert-close" (click)="closeAlert()">close</mat-icon>
      </div>
    </div>
  </ng-template>
</p-toast>